import { FormEvent, useContext, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import Model from './Model';
import questionMarkOnChalkboard from '../../assets/images/question-mark-on-chalkboard-pixabay.jpeg';
import Button from '../../components/atoms/button';
import Input from '../../components/atoms/input';
import ModalContext from '../../utils/ModalContext';

export default function RecoverPassword() {
  const model = new Model();
  const emailField = {
    autoFocus: true,
    autoComplete: 'user',
    id: 'email',
    label: 'Email',
    placeholder: 'Enter email address',
    required: true,
    type: 'email',
  };

  const [email, setEmail] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  const { showAlertModal } = useContext(ModalContext);

  useEffect(() => {
    document.title = 'Recover Password';
  });

  function onPasswordRecovery(event: FormEvent) {
    setIsDisabled(true);
    event.preventDefault();

    model
      .recoverPassword(email)
      .then(() => onSuccess())
      .catch(error => onFailure(error));
  }

  function onSuccess() {
    showAlertModal('We sent you an email. Check your spam box as well.');
    setEmail('');
    setIsDisabled(false);
  }

  function onFailure(error: any) {
    console.error(error);
    showAlertModal(`We are sorry, the email ${email} is not on our database. Please check again.`);
    setIsDisabled(false);
  }

  return (
    <div id="signin" className="recover-password dual-hero-form">
      <section className="column column-form">
        <form className="form" onSubmit={onPasswordRecovery}>
          <h1 className="title">Sometimes we forget</h1>
          <p className="subtitle">
            If you&apos;ve forgotten your password, enter the email used to create the account.
          </p>
          <Input {...emailField} state={[email, setEmail]} />
          <br />
          <Button className="button w-full" type="submit" disabled={isDisabled}>
            Recover password
          </Button>
          <br />
          <br />
          <Link className="link-button" to="/signin">
            Go back to Sign In
          </Link>
        </form>
      </section>

      <section className="column column-hero">
        <img src={questionMarkOnChalkboard} alt="A question mark on chalkboard" />
      </section>
    </div>
  );
}
